/**
 * TODO: Replace with ProductCart.js
 */
import React from 'react';
import { START, QUOTED, PRICE_SELECTED, ERROR } from 'pu-data/QuoteSteps';

class ProductCartForm extends React.Component {
  static isValid() {
    if (!jQuery('#quote_form').valid()) {
      vfShowModalErrors('One or more required fields are missing');
      vfScrollToError();
      return false;
    }
    return true;
  }

  constructor(props) {
    super(props);
    this.onClick = this.onClick.bind(this);
    this._onAddToCart = this._onAddToCart.bind(this);
    this.checkErrors = this.checkErrors.bind(this);
  }

  onClick() {
    if (this.props.onAddToCart) {
      this.props.onAddToCart();
    } else {
      if (!this._onAddToCart()) {
        return;
      }
      jQuery('#quote_form').submit();
    }
  }

  _onAddToCart() {
    if (!this.checkErrors()) { return false; }
    if (!ProductCartForm.isValid()) { return false; }
    if (this.addtionalValidations) {
      if (!this.addtionalValidations()) {
        return false;
      }
    }
    return true;
  }

  checkErrors() {
    const errors = [];
    if (this.props.quoteStep === START) {
      errors.push('Fill the form and get a quote before add to cart');
    } else if (this.props.useButtonQuote && this.props.parametersChanged === true) {
      errors.push('One or more parameters have changed. Please get a new quote');
    } else if (this.props.usePriceMatrix && this.props.quoteStep === QUOTED) {
      errors.push('You must select a price from the price matrix before adding to the cart.');
    } else if (this.props.quoteStep === ERROR) {
      errors.push('Our most sincere apologies something went wrong, please contact the administrator');
    } else {
      if (!jQuery('#part-number').valid()) {
        let projectType = 'printer circuit board';
        if (this.props.projectType === 'stencil' )
          projectType = 'stencil';
        errors.push(`Please enter the name or part number you use to identify your ${projectType}.`);
      }
      const revision = jQuery('#revision');
      if (revision.length && !revision.valid()) {
        errors.push('Please enter the revision for this design.');
      }

      if (this.props.usePriceMatrix && jQuery('input[name="parameters[price_matrix]"]:checked').length === 0) {
        errors.push('Please select a price from one of the matrices below');
      }
    }

    if (errors.length > 0) {
      vfShowModalErrors(errors);
      // alert(errors);
      return false;
    }
    return true;
  }

  render() {
    const properties = this.props.properties || [];
    const { unitPrice, totalPrice } = this.props;
    return (
      <div className="inside-product-cart">
        <span className="selection-label px-3 py-2 d-block">Pricing Information</span>

        {properties.map((p, idx) => (
          <div key={idx} className="form-inline product-property ps-3 pe-2 mb-2">
            <div className="form-group">
              <span className="product-property-label fw-bold">{p.label}</span>
              <span className="product-property-value">{p.value}</span>
            </div>
          </div>
        ))}

        <div className="inside-product-cart-b">
          <hr className="product-unit-price-separator" />
          <div className="clearfix fw-bold">
            <span>Unit Price:</span>
            <span className="product-unit-price" > {unitPrice}</span>
          </div>
          <div className="total ps-3 py-2 mt-3 mb-4">
            <span className="product-total-label">Total:</span>
            <span className="product-total"> {totalPrice}</span>
          </div>
        </div>
        <input type="button" className="btn btn-main-action fw-bold text-uppercase ms-3 mb-3" onClick={this.onClick} value="Add To Cart" />
      </div>
    );
  }
}

ProductCartForm.defaultProps = {
  usePriceMatrix: true,
  useButtonQuote: true,
  projectType: 'pcb',
};

export default ProductCartForm;
